import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pop-up-aviso',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './pop-up-aviso.component.html',
  styleUrls: ['./pop-up-aviso.component.scss'],
})
export class PopUpAvisoComponent implements OnInit {
  private static readonly STORAGE_KEY_BASE = 'popup_home_busca_empresas';

  /**
   * Única fonte de verdade pra chave do localStorage — quem decide se
   * mostra o popup (home.component.ts) e quem marca como visto (aqui
   * dentro) precisam concordar na mesma chave, senão o popup nunca fica
   * marcado como visto de verdade.
   */
  static getStorageKey(userId?: string): string {
    return userId
      ? `${PopUpAvisoComponent.STORAGE_KEY_BASE}_${userId}`
      : PopUpAvisoComponent.STORAGE_KEY_BASE;
  }

  BASE_IMG_URL: string = environment.BASE_IMG_URL;
  @Input() userId?: string;
  @Output() onClose = new EventEmitter<void>();

  constructor(
    public bsModalRef: BsModalRef,
    private readonly router: Router,
  ) {}

  ngOnInit() {}

  private get storageKey(): string {
    return PopUpAvisoComponent.getStorageKey(this.userId);
  }

  private marcarComoVisto(): void {
    localStorage.setItem(this.storageKey, 'true');
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.onCloseModal();
  }

  onCloseModal(): void {
    this.marcarComoVisto();
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    this.onClose.emit();
  }

  onImagemClick(): void {
    this.marcarComoVisto();
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
    this.router.navigate(['/empresas']);
  }

  onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.onCloseModal();
    }
  }
}
